import * as React from 'react';

interface InputProps {
  type?: 'text' | 'password' | 'number';
  name: string;
  value?: string;
  placeholder?: string;
  onChange?: (e: React.ChangeEvent) => void;
}

const Input = ({ type, name, value, placeholder, onChange }: InputProps) => {
  return (
    <input
      className="form-control"
      type={type || 'text'}
      name={name}
      value={value}
      placeholder={placeholder}
      onChange={onChange}
    />
  );
};

export default Input;
